<template>
  <div class="card chart-card-stub">{{ index }}</div>
</template>

<script>
export default {
  props: ['index']
}
</script>

<style lang="scss" scoped>
.chart-card-stub {
  min-width: 270px;
  max-width: 1fr;
  height: 470px;
}
</style>
